import { isDev } from "./commonMobile";
import { getGameCode } from "./gamePcode";

import Desktop from "../components/Desktop";
import MobileLobby from "../components/MobileLobby";
import MobileGame from "../components/MobileGame";

import socketIOClient from "socket.io-client";
import { IUserdataType, IGameType } from "@/types/GlobalTypes";


// Set manually if userdata.user.regionSocket is either empty or is "-"
const socketserver = (
	""
	// "http://localhost:8003/"
	// "https://socketdev.menangtoto.pw" // new dev

	// Live 192 & 56 (1 build each)
	// "https://socket.menangtoto.pw" // live build
	// "https://socket2.menangtoto.pw/"  // live buildwltoto
	// "https://socketwltoto2.menangtoto.pw" // live buildwltoto2
	// "https://socketcompany.menangtoto.pw/" // live buildcompany
	// "https://socketpay4D.menangtoto.pw" //build pay 4D
	// "https://socketb2b.menangtoto.pw" // live buildb2b
	// "https://socketbalancing.menangtoto.pw" // Live 58, 59 & 93: buildbalancing
	
	//Misc
	// "http://10.10.1.3:8003/"
	// "http://dev2.menangtoto.pw/" //dev.menangtoto new cluster
	// "http://43.246.217.22:8003/"
	// "http://43.246.216.38:8003/" //dev.menangtoto.pw
	// "http://43.246.217.22:9192" //dev

	// "https://newlobby.menangtoto.pw/" //live
	// "http://43.246.217.22:9191" //new live 2
);

// Usage: initSocketIO() in Lobby, LobbyMobile & MaximizeMobileGame
// Only if userdata.user.regionSocket is not empty & is not "-"
const socketServers = {
	"local": "https://socket.menangtoto.pw",
	"dev": "https://socketdev.menangtoto.pw", // new dev

	"live": "https://socket.menangtoto.pw", // live build
	"wltoto": "https://socket2.menangtoto.pw/", // live buildwltoto
	"company": "https://socketcompany.menangtoto.pw/" // live buildcompany
};

/**
 * Returns the Socket.io URL in use.
 * @param userdata The userdata object.
 */
function getSocketEndpoint(userdata: IUserdataType) {
    const { regionSocket, socketUrl } = userdata.user;

    return socketUrl
		? socketUrl
		: (regionSocket && regionSocket !== "-")
		? socketServers[regionSocket]
		: socketserver;
}

function getDefaultSocketParameters(userdata: IUserdataType) {
	const { nickname, operatorId } = userdata.user;

	return {
		//rememberTransport: false,
		transports: ["websocket"],
		upgrade: false,
		query: `user=${nickname}&agent=${operatorId}`
	};
}

/**
 * Usage: componentWillUnmount()
 * @param socket The reference to Socket.io object.
 */
function turnOffSocketEvents(socket: typeof socketIOClient) {
	const socketEvents = [
		"loadNewValue",
		"closeTimer",
		"receive_balance",
		"receive_totalwin",
		"show_banker",
		"show_player",

		"niuniuScan",
		"lottoScan",
		"shioFightScan",

		//Misc socket events
		"user_recount",
		"connect_failed",
		"disconnect",
		"reconnect_attempt",

		//User Recount
		"lobby_disconnect",
		"lobby_connect"
	];

	socketEvents.forEach(eventName => {
		// console.log("cWU eN", eventName);
		socket.off(eventName);
	});

	["", "b", "c"].forEach(variant => {
		socket.off(`baccarat${variant.toUpperCase()}`);
		socket.off(`scanDragonTiger${variant.toUpperCase()}`);
		socket.off(`baccaratNewSet${variant.toUpperCase()}`);
		socket.off(`dragonTigerNewSet${variant.toUpperCase()}`);
	});
}

function emitGameConnect(
	mainClass: Desktop | MobileLobby | MobileGame,
	userdata: IUserdataType,
	game: IGameType
) {
	// connects to the socket IO on the server
	const senddata = JSON.parse(JSON.stringify(userdata));
	delete senddata.user.displayNickname;
	
	senddata.pcode = game.pcode;
	senddata.game = getGameCode(game.pcode);

	if (isDev()) {
		console.warn("(dummy in client -- all rooms must be changed on the server)\n" +
			"gameConnect rooms:\n" +
			"\"" + senddata.user.nickname + " " + senddata.user.operatorId + "\"\n" +
			"\"" + senddata.user.nickname + " " + senddata.user.operatorId + " " + senddata.pcode + "\"\n" +
			"\"" + senddata.pcode + "\""
		);
	}

	// Joins a "gameroom" on server
	mainClass.socketio.emit("gameConnect", JSON.stringify(senddata), (data: any) => {
		console.log("gameConnect returned data: ", data);
		console.warn("connected");
	});
	
	game.isGameConnected = true;
}

function emitGameDisconnect(
	mainClass: Desktop | MobileLobby | MobileGame,
	userdata: IUserdataType,
	game: IGameType
) {
	// connects to the socket IO on the server
	const senddata = JSON.parse(JSON.stringify(userdata));
	senddata.pcode = game.pcode;
	senddata.game = getGameCode(game.pcode);

	mainClass.socketio.emit("gameDisconnect", JSON.stringify(senddata));
	console.warn("disconnected");
	game.isGameConnected = false;
}

function emitLobbyConnect(
	mainClass: Desktop | MobileLobby | MobileGame,
	userdata: IUserdataType
) {
	//Emits lobby connection in order to count active users
	const senddata = JSON.parse(JSON.stringify(userdata)) as IUserdataType;
	delete senddata.user.displayNickname;

	//Initiates socket IO lobby connect to server
	mainClass.socketio.emit("lobby_connect", JSON.stringify(senddata), data => {
		console.log("lobby_connect returned data: ", data);
	});

	mainClass.hasEmittedLobbyConnect = true;
}

function emitLobbyDisconnect(
	mainClass: Desktop | MobileLobby | MobileGame,
	userdata: IUserdataType
) {
	// Emits lobby disconnection in order to count active users
	const senddata = JSON.parse(JSON.stringify(userdata));

	// Initiates socket IO
	mainClass.socketio.emit("lobby_disconnect",
		JSON.stringify(senddata),
		(data: any) => {
			console.log("lobby_disconnect returned data: ", data);
	});
}

export {
	socketserver, socketServers,
	getSocketEndpoint, getDefaultSocketParameters, turnOffSocketEvents,

	emitGameConnect, emitGameDisconnect, emitLobbyConnect, emitLobbyDisconnect,
};